const open = ({ modal }) => modal?.map?.open;

export { open };
